import Line from "./Line";

export default {
  name: "LineChartRelative",
  extends: Line,
  data() {
    return {
      lineChartDefaultOptions: {
        scales: {
          scaleStartValue: 0,
          yAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: false
              },
              ticks: {
                display: true,
                fontSize: 16,
                fontFamily: "Montserrat",
                fontColor: "#c3c5cd",
                padding: 8,
                stepSize: 1,
                beginAtZero: true,
                maxTicksLimit: 8,
                callback: function(value) {
                  if (value <= 100) {
                    return value + "%";
                  }
                  return;
                },
                max: 110
              },
              display: true
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return tooltipItem.value + "%";
            }
          }
        }
      }
    };
  }
};
